"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getServiceItemIds_1 = require("./utils/getServiceItemIds");
var markAsJunkRequest_1 = require("owa-service/lib/factory/markAsJunkRequest");
var markAsJunkOperation_1 = require("owa-service/lib/operation/markAsJunkOperation");
var ServiceRequestUtils_1 = require("owa-service/lib/ServiceRequestUtils");
var owa_mail_strings_1 = require("owa-strings/owa-mail-strings");
/**
 * Configure the mark as junk/not junk request Body
 * @param itemIdsToUpdate an array of the item id strings to be updated
 * @param isJunk whether it is a mark as junk action or not
 * @return the request body for mark as junk service request
 */
function configureRequestBody(itemIdsToUpdate, isJunk) {
    var markAsJunkRequestData = {
        ItemIds: getServiceItemIds_1.default(itemIdsToUpdate),
        IsJunk: isJunk,
        MoveItem: true,
        SendCopy: false,
        JunkMessageHeader: owa_mail_strings_1.default.junkMessageHeader,
        JunkMessageBody: owa_mail_strings_1.default.junkMessageBody,
    };
    return markAsJunkRequest_1.default(markAsJunkRequestData);
}
/**
 * Submit the mark as junk service request
 * @param itemIds the item ids to be updated
 * @param isJunk whether it is a mark as junk action or not
 * @return the MarkAsJunkResponseMessage
 */
function markConversationAsJunkService(itemIdsToUpdate, isJunk) {
    var requestBody = configureRequestBody(itemIdsToUpdate, isJunk);
    return markAsJunkOperation_1.default({
        Header: ServiceRequestUtils_1.getJsonRequestHeader(),
        Body: requestBody,
    }).then(function (response) {
        return response.Body.ResponseMessages.Items[0];
    });
}
exports.default = markConversationAsJunkService;
//# sourceMappingURL=markAsJunkService.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/data/owa-mail-store/lib/services/markAsJunkService.js
// module id = 5656
// module chunks = 62